import React, { useContext } from 'react'
import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'
import { Form, Alert, Box } from '@smooth-ui/core-sc'
import useInputValue from '@rehooks/input-value'
import { Redirect, Link } from 'react-router-dom'

import trackGMT from 'helpers/gtm'
import PageWrapper from 'components/PageWrapper/PageWrapper'
import {
  PageTitle,
  SpinnerButton,
  GrayBox,
  FormField,
  P,
  A
} from 'components/Elements/index'
import TokenContext from 'helpers/tokenContext'

import routeConfig from 'routeConfig'
import config from 'config'

const name = 'Logg inn'

const loginMutation = gql`
  mutation login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      access_token
      message
    }
  }
`

const Login = ({ history: { replace } }) => {
  const { token, setToken } = useContext(TokenContext)
  const email = useInputValue('')
  const password = useInputValue('')
  const [login, { data, loading, error }] = useMutation(loginMutation)
  const onSubmit = async event => {
    event.preventDefault()
    try {
      const {
        data: { login: payload }
      } = await login({
        variables: {
          email: email.value.trim(),
          password: password.value.trim()
        }
      })
      trackGMT({
        event: 'custom',
        category: 'Login',
        action: payload.message || 'Success',
        label: 'Success'
      })
      await setToken(payload.access_token)
    } catch (error) {
      trackGMT({
        event: 'custom',
        category: 'Login',
        action: 'Error',
        label: `${error.message} (${email.value.trim()})`
      })
    }
  }
  if (token) {
    return <Redirect to={routeConfig.home} />
  }
  return (
    <PageWrapper title={name}>
      <Box width={{ sm: 1, md: 0.5 }} mx="auto">
        <PageTitle color="primary" fontSize="2rem">
          {name}
        </PageTitle>
        {error && <Alert variant="danger">Feil brukernavn eller passord</Alert>}
        <GrayBox>
          <Form onSubmit={onSubmit} mb={2}>
            <FormField
              name="email"
              placeholder={`E-post ${
                config.enableUsernameLogin ? ' eller brukernavn' : ''
              }`}
              inputMode="email"
              autoComplete="email"
              field={email}
              autoCapitalize="none"
            />
            <FormField
              name="password"
              type="password"
              placeholder="Passord"
              autoComplete="current-password"
              field={password}
              autoCapitalize="none"
            />
            <SpinnerButton
              working={loading || !!data}
              text="Logg inn"
              textWorking="Logger inn"
              type="submit"
              alignItems="center"
              justifyContent="center"
              width="100%"
              scale="lg"
            />
          </Form>
        </GrayBox>
        <P>
          Glemt passord?{' '}
          <A as={Link} to={routeConfig.forgotPassword}>
            gå her får å lage nytt
          </A>
        </P>
      </Box>
    </PageWrapper>
  )
}

export default Login
